module.exports = __webpack_public_path__ + "static/media/precisioneffect.cd569fb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logos/precisioneffect.png
// module id = 61
// module chunks = 0